module.exports = __webpack_public_path__ + "static/projectPlanningImage-9ff4bda52f12ecb943d4317df34ab781.jpg";